import { McSearchResultDTO } from "@landtechnologies/dtos";
import { useContext, useEffect, useMemo, useState } from "react";
import { dryRunSite, getGeometriesForResult } from "../utils";
import { SaveSiteLayer } from "react-migration/domains/sites";
import { MultiPolygon } from "@turf/helpers";
import { Site } from "react-migration/domains/sites/typings";
import { getPaginationContextReference } from "@landtechnologies/components";

type UseInitialInformationForResultsParams = {
  currentPageResults: McSearchResultDTO[];
  layer: SaveSiteLayer;
};

export const useInitialInformationForResults = ({
  currentPageResults,
  layer,
}: UseInitialInformationForResultsParams) => {
  const [dryRunSites, setDryRunSites] = useState<Array<Site | null | undefined>>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [geometries, setGeometries] = useState<MultiPolygon[]>([]);
  const { currentPageInternal } = useContext(getPaginationContextReference());

  useEffect(() => {
    (async () => {
      setDryRunSites([]);
      const promises = currentPageResults
        .filter((result) => result.centroid)
        .map(async (result) => {
          const geometry = await getGeometriesForResult({ geometry_id: result.geometry_id });
          const dryRun = await dryRunSite({
            site: {
              geometry,
              source: { layer },
            },
          });
          setDryRunSites((prev) => [...prev, dryRun]);
          return geometry;
        });
      setIsLoading(true);
      const results = await Promise.all(promises);
      setGeometries(results);
      setIsLoading(false);
    })();
  }, [currentPageResults, layer, currentPageInternal]);
  const allSitesAreSaved = useMemo(() => dryRunSites.every((dryRun) => dryRun), [dryRunSites]);

  return {
    isLoading,
    geometries,
    allSitesAreSaved,
  };
};
